<div class="client-documents">
  <div class="client-documents__filters">
    <div class="client-documents__filters-row">
      <label>
        Search:
        <input
          type="text"
          [(ngModel)]="searchTerm"
          placeholder="Search by file name or notes"
        />
      </label>

      <label>
        Tag filter:
        <input
          type="text"
          [(ngModel)]="tagFilter"
          placeholder="Filter by tag, e.g. consent_form"
        />
      </label>

      <button type="button" (click)="loadDocuments()">
        Apply
      </button>

      <button
        type="button"
        (click)="searchTerm = ''; tagFilter = ''; loadDocuments()"
      >
        Clear
      </button>
    </div>
  </div>

  <div *ngIf="loading" class="client-documents__status">
    Loading documents...
  </div>

  <div *ngIf="error" class="client-documents__status client-documents__status--error">
    {{ error }}
  </div>

  <div
    *ngIf="!loading && !error && documents.length === 0"
    class="client-documents__status"
  >
    No documents uploaded for this client yet.
  </div>

  <table
    *ngIf="!loading && !error && documents.length > 0"
    class="client-documents__table"
  >
    <thead>
      <tr>
        <th>File Name</th>
        <th>Tags</th>
        <th>Type</th>
        <th>Notes</th>
        <th>Uploaded</th>
        <th>Actions</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let doc of documents">
        <td>{{ doc.fileName }}</td>
        <td>{{ normalizeTags(doc).join(", ") }}</td>
        <td>{{ doc.documentType || "-" }}</td>
        <td>{{ doc.notes || "-" }}</td>
        <td>{{ doc.createdAt | date: "short" }}</td>
        <td>
          <div class="client-documents__actions">
            <button type="button" (click)="download(doc)">
              Download
            </button>
            <button
              type="button"
              class="client-documents__button--danger"
              (click)="openDeleteConfirm(doc)"
              [disabled]="deletingDocumentId === doc.id"
            >
              {{ deletingDocumentId === doc.id ? "Deleting..." : "Delete" }}
            </button>
          </div>
        </td>
      </tr>
    </tbody>
  </table>

  <div class="client-documents__upload">
    <div class="client-documents__upload-row">
      <label>
        File:
        <input
          type="file"
          (change)="onFileSelected($event)"
          accept="image/*,application/pdf"
        />
      </label>
    </div>

    <div class="client-documents__upload-row">
      <label>
        Tags:
        <input
          type="text"
          [(ngModel)]="uploadTags"
          placeholder="e.g. consent_form, referral"
        />
      </label>
    </div>

    <div class="client-documents__upload-row">
      <label>
        Document type:
        <input
          type="text"
          [(ngModel)]="uploadDocumentType"
          placeholder="e.g. consent_form"
        />
      </label>
    </div>

    <div class="client-documents__upload-row">
      <label>
        Notes:
        <input
          type="text"
          [(ngModel)]="uploadNotes"
          placeholder="Optional notes"
        />
      </label>
    </div>

    <div class="client-documents__upload-row">
      <button
        type="button"
        (click)="upload()"
        [disabled]="uploading || !selectedFile"
      >
        {{ uploading ? "Uploading..." : "Upload" }}
      </button>
    </div>

    <div
      *ngIf="uploadError"
      class="client-documents__status client-documents__status--error"
    >
      {{ uploadError }}
    </div>
  </div>
</div>

<ng-template #deleteConfirmModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Delete document?</h5>
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="cancelDelete()"
      [disabled]="!!deletingDocumentId"
    ></button>
  </div>
  <div class="modal-body">
    <p>
      Are you sure you want to delete
      <strong>{{ pendingDeleteDocument?.fileName || "this document" }}</strong>?
    </p>

    <div
      *ngIf="deleteError"
      class="client-documents__status client-documents__status--error"
    >
      {{ deleteError }}
    </div>
  </div>
  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-secondary"
      (click)="cancelDelete()"
      [disabled]="!!deletingDocumentId"
    >
      Cancel
    </button>
    <button
      type="button"
      class="btn btn-danger"
      (click)="confirmDelete()"
      [disabled]="!!deletingDocumentId"
    >
      {{ deletingDocumentId ? "Deleting..." : "Delete" }}
    </button>
  </div>
</ng-template>
